import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../apiCalls/rtkBaseQuery';
import { LIST_TRAINING,LIST_TRAINING_CERTIFICATE } from '../../../apiCalls/urls/training';
import { GET_LIST } from '../../../apiCalls/urls/common';
export const trainingHistoryApi = createApi({
    baseQuery,
    tagTypes: ['trainingHistory'],
    reducerPath: 'trainingHistoryApi',
    endpoints: (builder) => ({
        getTraininghistoryList: builder.query({
            query: (bodyData) => ({
                url: LIST_TRAINING,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['trainingHistory'],
            refetchOnMountOrArgChange: true,
        }),
        getTrainingCertificateList: builder.query({
            query: (bodyData) => ({
                url: LIST_TRAINING_CERTIFICATE,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['trainingHistory'],
            refetchOnMountOrArgChange: true,
        }),
        getList: builder.mutation({
            query: (bodyData) => ({
                url: GET_LIST,
                method: 'POST',
                body: bodyData || {}
            }),
            refetchOnMountOrArgChange: false,
        })
    }),
});

export const {
    useGetTraininghistoryListQuery,
    useGetListMutation,
    useGetTrainingCertificateListQuery
} = trainingHistoryApi;